export default __webpack_public_path__ + "static/media/bikbok.b2f1d752.png";